/* JRS Farm Parts theme — global JS */
(function () {
  "use strict";
  document.documentElement.classList.remove("no-js");

  // Close any open <dialog> when clicking its backdrop
  document.addEventListener("click", function (e) {
    var dlg = e.target.closest("dialog");
    if (dlg && e.target === dlg) dlg.close();
  });

  // ---- AJAX add-to-cart (stay on page, update count, show toast) ----
  document.addEventListener("submit", function (e) {
    var form = e.target;
    var sub = e.submitter || (document.activeElement && document.activeElement.form === form ? document.activeElement : null);
    // Only intercept the "Add to cart" button; let Buy now / checkout submit normally
    if (!sub || sub.name !== "add") return;
    if (!form.querySelector('[name="id"]')) return;
    e.preventDefault();

    var orig = sub.innerHTML;
    sub.disabled = true;
    sub.innerHTML = "Adding…";

    fetch("/cart/add.js", { method: "POST", headers: { Accept: "application/json" }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function (item) {
        return fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
          updateCartCount(cart.item_count);
          showToast("✓ Added to cart", item.product_title || item.title || "");
        });
      })
      .catch(function (err) { showToast("Could not add to cart", (err && err.description) || ""); })
      .finally(function () { sub.disabled = false; sub.innerHTML = orig; });
  });

  function updateCartCount(n) {
    var cart = document.querySelector(".header__cart");
    if (!cart) return;
    var b = cart.querySelector(".cart-count");
    if (!b) { b = document.createElement("span"); b.className = "cart-count"; cart.appendChild(b); }
    b.textContent = n;
    b.style.display = n > 0 ? "" : "none";
  }

  // ---- Display-only currency converter (checkout stays INR) ----
  var SYM = { INR: "₹", USD: "$", EUR: "€", GBP: "£", AED: "AED ", BRL: "R$", MXN: "MX$" };
  var DEC = { INR: 0, USD: 2, EUR: 2, GBP: 2, AED: 2, BRL: 2, MXN: 2 };
  var perUnit = Object.assign({ INR: 1 }, window.JRS_FX_MANUAL || {}); // INR per 1 unit of currency

  function currentCurrency() {
    try { return localStorage.getItem("jrs_currency") || "INR"; } catch (e) { return "INR"; }
  }
  function applyCurrency() {
    var c = currentCurrency();
    var sel = document.getElementById("jrs-currency");
    if (sel && sel.value !== c) sel.value = c;
    var moneyEls = document.querySelectorAll(".js-money");
    for (var i = 0; i < moneyEls.length; i++) {
      var el = moneyEls[i];
      if (c === "INR" || !perUnit[c]) { el.textContent = el.getAttribute("data-orig"); continue; }
      var inr = parseInt(el.getAttribute("data-money"), 10) / 100;
      var v = inr / perUnit[c];
      el.textContent = (SYM[c] || c + " ") + v.toLocaleString("en", { minimumFractionDigits: DEC[c], maximumFractionDigits: DEC[c] });
    }
    var note = document.querySelector(".js-fx-note");
    if (note) {
      if (c !== "INR") { note.style.display = "block"; note.textContent = "Prices shown in " + c + " are approximate — you'll be charged in INR at checkout."; }
      else { note.style.display = "none"; }
    }
  }
  function initCurrency() {
    var sel = document.getElementById("jrs-currency");
    if (sel) {
      sel.value = currentCurrency();
      sel.addEventListener("change", function () {
        try { localStorage.setItem("jrs_currency", sel.value); } catch (e) {}
        applyCurrency();
      });
    }
    applyCurrency(); // manual rates first (instant)
    fetch("https://open.er-api.com/v6/latest/INR")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d && d.rates) { for (var k in SYM) { if (d.rates[k]) perUnit[k] = 1 / d.rates[k]; } perUnit.INR = 1; applyCurrency(); }
      })
      .catch(function () {});
  }
  if (document.readyState !== "loading") initCurrency();
  else document.addEventListener("DOMContentLoaded", initCurrency);

  function showToast(title, sub) {
    var t = document.getElementById("jrs-toast");
    if (!t) { t = document.createElement("div"); t.id = "jrs-toast"; document.body.appendChild(t); }
    t.innerHTML =
      '<div class="jrs-toast__msg"><strong>' + title + "</strong>" +
      (sub ? '<span>' + sub + "</span>" : "") + "</div>" +
      '<a href="/cart" class="jrs-toast__link">View cart →</a>';
    t.classList.add("show");
    clearTimeout(t._to);
    t._to = setTimeout(function () { t.classList.remove("show"); }, 3800);
  }
})();
